import React, { useState, useEffect } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaCheck, FaPlus, FaSync, FaSearch, FaFilter, FaEye, FaUnlink } from 'react-icons/fa';
import Paginacao from '../../../../components/utils/paginacao';
import BuscarLancamento from './BuscarLancamento';
import CriarLancamento from './CriarLancamento';

const DetalheImportacao = ({ importacao, onClose, onAtualizar }) => {

    const [importacaoAtual, setImportacaoAtual] = useState(importacao);
    const [transacoes, setTransacoes] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [filtroStatus, setFiltroStatus] = useState('todas');
    const [transacaoSelecionada, setTransacaoSelecionada] = useState(null);
    const [showModalBuscar, setShowModalBuscar] = useState(false);
    const [showModalCriar, setShowModalCriar] = useState(false);
    const [showModalLancamento, setShowModalLancamento] = useState(false);
    const [lancamentoSelecionado, setLancamentoSelecionado] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const limit = 15;

    useEffect(() => {
        fetchTransacoes(currentPage, filtroStatus);
    }, [currentPage]);

    const fetchImportacao = async () => {
        try {
            const response = await api.get(`/conciliacao/${importacao.id}`);
            setImportacaoAtual(response.data);
        } catch (error) {
        }
    };

    const fetchTransacoes = async (page = currentPage, status = filtroStatus) => {
        setCarregando(true);
        try {
            const params = { page, limit };
            if (status === 'pendentes') params.status = 'pendente';
            if (status === 'conciliadas') params.status = 'conciliado';

            const response = await api.get(`/conciliacao/${importacao.id}/transacoes`, { params });
            setTransacoes(response.data.transacoes || []);
            setTotalPages(response.data.totalPaginas || 1);
            setTotalRegistros(response.data.totalRegistros || 0);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar transações', 'error');
        } finally {
            setCarregando(false);
        }
    };

    const handleReprocessar = async () => {
        try {
            Swal.fire({
                title: 'Reprocessando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            await api.post(`/conciliacao/${importacao.id}/reprocessar`);

            Swal.fire('Sucesso', 'Matching automático reprocessado', 'success');
            fetchTransacoes();
            fetchImportacao();
            onAtualizar();
        } catch (error) {
            Swal.fire('Erro', error.response?.data?.message || 'Erro ao reprocessar', 'error');
        }
    };

    const handleBuscarManual = (transacao) => {
        setTransacaoSelecionada(transacao);
        setShowModalBuscar(true);
    };

    const handleCriarLancamento = (transacao) => {
        setTransacaoSelecionada(transacao);
        setShowModalCriar(true);
    };

    const handleConciliacaoManual = async (lancamentoId) => {
        try {
            Swal.fire({
                title: 'Conciliando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            await api.post(`/conciliacao/transacao/${transacaoSelecionada.id}/conciliar`, {
                lancamento_id: lancamentoId
            });

            Swal.fire('Sucesso', 'Transação conciliada com sucesso', 'success');
            setShowModalBuscar(false);
            setTransacaoSelecionada(null);
            fetchTransacoes();
            fetchImportacao();
            onAtualizar();
        } catch (error) {
            Swal.fire('Erro', error.response?.data?.message || 'Erro ao conciliar', 'error');
        }
    };

    const handleLancamentoCriado = () => {
        setShowModalCriar(false);
        setTransacaoSelecionada(null);
        fetchTransacoes();
        fetchImportacao();
        onAtualizar();
    };

    const handleVerLancamento = (transacao) => {
        if (transacao.lancamento) {
            setLancamentoSelecionado(transacao.lancamento);
            setShowModalLancamento(true);
        }
    };

    const handleDesconciliar = async (transacao) => {
        const isCriado = transacao.status === 'criado';

        const result = await Swal.fire({
            title: 'Desvincular transação?',
            html: isCriado
                ? `<p>Esta transação teve um lançamento <strong>criado</strong> pela conciliação.</p><p>Ao desvincular, o lançamento Nº ${transacao.lancamento?.id} será <strong>cancelado</strong>.</p>`
                : `<p>Deseja desvincular esta transação do lançamento Nº ${transacao.lancamento?.id}?</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, desvincular',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                Swal.fire({
                    title: 'Desvinculando...',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const response = await api.post(`/conciliacao/transacao/${transacao.id}/desconciliar`);

                Swal.fire('Sucesso', response.data.message, 'success');
                fetchTransacoes();
                fetchImportacao();
                onAtualizar();
            } catch (error) {
                Swal.fire('Erro', error.response?.data?.message || 'Erro ao desvincular', 'error');
            }
        }
    };

    const formatarData = (dataString) => {
        if (!dataString) return '-';
        if (dataString.includes('T')) {
            dataString = dataString.split('T')[0];
        }
        if (dataString.includes('-')) {
            const [ano, mes, dia] = dataString.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        return dataString;
    };

    const formatarValor = (valor) => {
        if (!valor) return 'R$ 0,00';
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    const formatarStatus = (status, conciliadoManualmente) => {
        const statusMap = {
            'pendente': 'Pendente',
            'conciliado': conciliadoManualmente ? 'Conc. Manual' : 'Conc. Auto',
            'ignorado': 'Ignorado',
            'criado': 'Conc. Novo',
            'cancelado': 'Cancelado'
        };
        return statusMap[status] || status;
    };

    const getCorStatus = (status) => {
        const cores = {
            'pendente': 'bg-warning',
            'conciliado': 'bg-success',
            'ignorado': 'bg-secondary',
            'criado': 'bg-primary',
            'cancelado': 'bg-dark'
        };
        return cores[status] || 'bg-secondary';
    };

    const handleFiltrar = () => {
        setCurrentPage(1);
        fetchTransacoes(1, filtroStatus);
    };

    const calcularConciliadas = () => {
        if (importacaoAtual.transacoes_conciliadas !== undefined) {
            return importacaoAtual.transacoes_conciliadas;
        }
        return (importacaoAtual.total_conciliadas || 0) + (importacaoAtual.total_criadas || 0);
    };

    const estatisticas = {
        total: importacaoAtual.total_transacoes || 0,
        pendentes: importacaoAtual.total_pendentes !== undefined
            ? importacaoAtual.total_pendentes
            : (importacaoAtual.total_transacoes || 0) - calcularConciliadas(),
        conciliadas: calcularConciliadas()
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '1400px' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Conciliação</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card info-card mb-3">
                            <div className="card-body p-3">
                                <div className="row">
                                    <div className="col-lg-4 col-12 mb-lg-0 mb-1">
                                        <strong>Arquivo:</strong> {importacaoAtual.nome_arquivo}
                                    </div>
                                    <div className="col-lg-4 col-12 mb-lg-0 mb-1">
                                        <strong>Conta:</strong> {importacaoAtual.contaBancaria?.nome_exibicao || importacaoAtual.contaBancaria?.nome}
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <strong>Período:</strong> {formatarData(importacaoAtual.periodo_inicio)} - {formatarData(importacaoAtual.periodo_fim)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12 text-center">
                                <span className="me-4">Total: <strong>{estatisticas.total}</strong></span>
                                <span className="me-4">Pendentes: <strong>{estatisticas.pendentes}</strong></span>
                                <span>Conciliadas: <strong>{estatisticas.conciliadas}</strong></span>
                            </div>
                        </div>

                        {estatisticas.pendentes > 0 && (
                            <div className="row mb-3 align-items-end">
                                <div className="col-lg-3 col-12">
                                    <label className="form-label fw-bold">Status</label>
                                    <select
                                        className="form-select"
                                        value={filtroStatus}
                                        onChange={(e) => setFiltroStatus(e.target.value)}
                                    >
                                        <option value="todas">Todas</option>
                                        <option value="pendentes">Pendentes</option>
                                        <option value="conciliadas">Conciliadas</option>
                                    </select>
                                </div>
                                <div className="col-lg-5 col-12 mt-lg-0 mt-3 text-lg-start text-end">
                                    <button className="btn btn-custom-primary" onClick={handleFiltrar}>
                                        <FaFilter className="me-1" /> Filtrar
                                    </button>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3 text-end">
                                    <button className="btn btn-outline-primary" onClick={handleReprocessar}>
                                        <FaSync className="me-1" /> Reprocessar Matching
                                    </button>
                                </div>
                            </div>
                        )}

                        {carregando ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 350px)', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark sticky-top">
                                        <tr>
                                            <th className="text-nowrap">Data</th>
                                            <th className="text-nowrap">Descrição</th>
                                            <th className="text-nowrap">Tipo</th>
                                            <th className="text-nowrap text-end">Valor</th>
                                            <th className="text-nowrap text-end">Saldo</th>
                                            <th className="text-nowrap text-center">Status</th>
                                            {importacaoAtual.status !== 'cancelado' && (
                                                <th className="text-nowrap text-center" style={{ width: '200px' }}>Ações</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transacoes.length > 0 ? (
                                            transacoes.map((transacao) => (
                                                <tr key={transacao.id}>
                                                    <td className="text-nowrap">
                                                        {formatarData(transacao.data_transacao)}
                                                    </td>
                                                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={transacao.descricao_original}>
                                                        {transacao.descricao_original}
                                                        {transacao.parcela_atual && transacao.parcela_total && (
                                                            <small className="text-muted d-block">
                                                                Parcela {transacao.parcela_atual}/{transacao.parcela_total}
                                                            </small>
                                                        )}
                                                    </td>
                                                    <td className="text-nowrap">
                                                        <span className={`badge ${transacao.tipo === 'credito' ? 'bg-success' : 'bg-danger'}`}>
                                                            {transacao.tipo === 'credito' ? 'Crédito' : 'Débito'}
                                                        </span>
                                                    </td>
                                                    <td className={`text-nowrap text-end fw-bold ${transacao.tipo === 'credito' ? 'text-success' : 'text-danger'}`}>
                                                        {transacao.tipo === 'credito' ? '+' : '-'} {formatarValor(Math.abs(transacao.valor))}
                                                    </td>
                                                    <td className="text-nowrap text-end">
                                                        {transacao.saldo_apos !== null && transacao.saldo_apos !== undefined
                                                            ? formatarValor(transacao.saldo_apos)
                                                            : ''}
                                                    </td>
                                                    <td className="text-nowrap text-center">
                                                        <span className={`badge ${getCorStatus(transacao.status)}`}>
                                                            {formatarStatus(transacao.status, transacao.conciliado_manualmente)}
                                                            {transacao.lancamento && ` #${transacao.lancamento.id}`}
                                                        </span>
                                                    </td>
                                                    {importacaoAtual.status !== 'cancelado' && (
                                                        <td className="text-nowrap text-center">
                                                            {transacao.status === 'pendente' && (
                                                                <>
                                                                    <button
                                                                        className="btn btn-custom-secondary btn-sm"
                                                                        onClick={() => handleBuscarManual(transacao)}
                                                                        title="Buscar lançamento"
                                                                    >
                                                                        <FaSearch />
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-custom-secondary btn-sm ms-3"
                                                                        onClick={() => handleCriarLancamento(transacao)}
                                                                        title="Criar lançamento"
                                                                    >
                                                                        <FaPlus />
                                                                    </button>
                                                                </>
                                                            )}
                                                            {['conciliado', 'criado'].includes(transacao.status) && (
                                                                <>
                                                                    <span className="badge bg-success me-3" title="Conciliado">
                                                                        <FaCheck />
                                                                    </span>
                                                                    {transacao.lancamento && (
                                                                        <button
                                                                            className="btn btn-custom-secondary btn-sm"
                                                                            onClick={() => handleVerLancamento(transacao)}
                                                                            title="Ver lançamento"
                                                                        >
                                                                            <FaEye />
                                                                        </button>
                                                                    )}
                                                                    <button
                                                                        className="btn btn-custom-secondary btn-sm ms-3"
                                                                        onClick={() => handleDesconciliar(transacao)}
                                                                        title={transacao.status === 'criado' ? 'Desvincular e cancelar lançamento' : 'Desvincular'}
                                                                    >
                                                                        <FaUnlink />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={importacaoAtual.status === 'cancelado' ? 6 : 7} className="text-center">
                                                    Nenhuma transação encontrada
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {!carregando && totalRegistros > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <span>Total de registros: <strong>{totalRegistros}</strong></span>
                                <Paginacao
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={setCurrentPage}
                                />
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                    </div>
                </div>
            </div>

            {showModalBuscar && transacaoSelecionada && (
                <BuscarLancamento
                    transacao={transacaoSelecionada}
                    contaBancariaId={importacao.conta_bancaria_id}
                    onClose={() => {
                        setShowModalBuscar(false);
                        setTransacaoSelecionada(null);
                    }}
                    onSelecionar={handleConciliacaoManual}
                />
            )}

            {showModalCriar && transacaoSelecionada && (
                <CriarLancamento
                    transacao={transacaoSelecionada}
                    contaBancariaId={importacao.conta_bancaria_id}
                    onClose={() => {
                        setShowModalCriar(false);
                        setTransacaoSelecionada(null);
                    }}
                    onSalvar={handleLancamentoCriado}
                />
            )}

            {showModalLancamento && lancamentoSelecionado && (
                <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="fw-bold mt-2">Lançamento Nº {lancamentoSelecionado.id}</h4>
                                <button type="button" className="btn-close" onClick={() => setShowModalLancamento(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-2">
                                    <div className="col-lg-4 col-12">
                                        <span className="fw-bold">Nº:</span>
                                    </div>
                                    <div className="col-lg-8 col-12">
                                        {lancamentoSelecionado.id}
                                    </div>
                                </div>
                                {lancamentoSelecionado.numero_doc && (
                                    <div className="row mb-2">
                                        <div className="col-lg-4 col-12">
                                            <span className="fw-bold">Nº Documento:</span>
                                        </div>
                                        <div className="col-lg-8 col-12">
                                            {lancamentoSelecionado.numero_doc}
                                        </div>
                                    </div>
                                )}
                                <div className="row mb-2">
                                    <div className="col-lg-4 col-12">
                                        <span className="fw-bold">Descrição:</span>
                                    </div>
                                    <div className="col-lg-8 col-12">
                                        {lancamentoSelecionado.descricao || '-'}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-lg-4 col-12">
                                        <span className="fw-bold">Valor:</span>
                                    </div>
                                    <div className="col-lg-8 col-12 fw-bold">
                                        {formatarValor(lancamentoSelecionado.valor)}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-lg-4 col-12">
                                        <span className="fw-bold">Data Pagamento:</span>
                                    </div>
                                    <div className="col-lg-8 col-12">
                                        {formatarData(lancamentoSelecionado.data_pagamento)}
                                    </div>
                                </div>
                                {lancamentoSelecionado.data_vencimento && (
                                    <div className="row mb-2">
                                        <div className="col-lg-4 col-12">
                                            <span className="fw-bold">Data Vencimento:</span>
                                        </div>
                                        <div className="col-lg-8 col-12">
                                            {formatarData(lancamentoSelecionado.data_vencimento)}
                                        </div>
                                    </div>
                                )}
                                {lancamentoSelecionado.data_competencia && (
                                    <div className="row mb-2">
                                        <div className="col-lg-4 col-12">
                                            <span className="fw-bold">Data Competência:</span>
                                        </div>
                                        <div className="col-lg-8 col-12">
                                            {formatarData(lancamentoSelecionado.data_competencia)}
                                        </div>
                                    </div>
                                )}
                                <div className="row mb-2">
                                    <div className="col-lg-4 col-12">
                                        <span className="fw-bold">Categoria:</span>
                                    </div>
                                    <div className="col-lg-8 col-12">
                                        {lancamentoSelecionado.categoria?.nome || '-'}
                                        {lancamentoSelecionado.categoria?.tipo_financeiro && (
                                            <span className={`badge ms-2 ${lancamentoSelecionado.categoria.tipo_financeiro === 'receita' ? 'bg-success' : 'bg-danger'}`}>
                                                {lancamentoSelecionado.categoria.tipo_financeiro === 'receita' ? 'Receita' : 'Despesa'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-lg-4 col-12">
                                        <span className="fw-bold">Status:</span>
                                    </div>
                                    <div className="col-lg-8 col-12">
                                        <span className={`badge ${lancamentoSelecionado.status === 'conciliado' ? 'bg-success' : lancamentoSelecionado.status === 'pago' ? 'bg-primary' : 'bg-secondary'}`}>
                                            {lancamentoSelecionado.status === 'conciliado' ? 'Conciliado' : lancamentoSelecionado.status === 'pago' ? 'Pago' : lancamentoSelecionado.status}
                                        </span>
                                    </div>
                                </div>
                                {lancamentoSelecionado.observacao && (
                                    <div className="row mb-2">
                                        <div className="col-lg-4 col-12">
                                            <span className="fw-bold">Observação:</span>
                                        </div>
                                        <div className="col-lg-8 col-12">
                                            {lancamentoSelecionado.observacao}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-danger" onClick={() => setShowModalLancamento(false)}>
                                    <FaTimes className="me-1" />
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetalheImportacao;
